import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.002 512.002" style={{
  enableBackground: "new 0 0 512.002 512.002"
}} xmlSpace="preserve" ref={ref} {...props}><g><rect y={200.09} style={{
      fill: "#F5F5F5"
    }} width={185.38} height={37.27} /><path style={{
      fill: "#F5F5F5"
    }} d="M185.379,125.549h326.593c-0.569-20.68-17.5-37.272-38.317-37.272H38.345   C17.167,88.276,0,105.444,0,126.621v36.2h185.379V125.549z" /><path style={{
      fill: "#F5F5F5"
    }} d="M38.345,423.725h435.31c20.818,0,37.748-16.593,38.317-37.272H0.028   C0.597,407.132,17.527,423.725,38.345,423.725z" /></g><path style={{
    fill: "#4173CD"
  }} d="M185.379,125.549v37.272H512v-36.2c0-0.36-0.018-0.715-0.028-1.073L185.379,125.549L185.379,125.549z  " /><polygon style={{
    fill: "#F5F5F5"
  }} points="0,162.821 0,200.092 185.379,200.092 512,200.092 512,162.821 185.379,162.821 " /><rect x={185.38} y={200.09} style={{
    fill: "#4173CD"
  }} width={326.62} height={37.27} /><polygon style={{
    fill: "#F5F5F5"
  }} points="0,237.364 0,274.637 512,274.637 512,237.364 185.379,237.364 " /><rect y={274.64} style={{
    fill: "#4173CD"
  }} width={512} height={37.27} /><rect y={311.91} style={{
    fill: "#F5F5F5"
  }} width={512} height={37.27} /><path style={{
    fill: "#4173CD"
  }} d="M0,385.38c0,0.36,0.018,0.715,0.028,1.073h511.946c0.01-0.358,0.028-0.713,0.028-1.073v-36.2H0  V385.38z" /><polygon style={{
    fill: "#FFE15A"
  }} points="63.976,111.643 78.743,179.975 101.85,170.404 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="63.976,111.643 90.296,175.189 78.743,179.975 " /><polygon style={{
    fill: "#FFE15A"
  }} points="121.404,250.289 106.636,181.957 83.529,191.528 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="121.404,250.289 95.083,186.743 106.636,181.957 " /><polygon style={{
    fill: "#FFE15A"
  }} points="162.013,152.252 93.681,167.02 103.252,190.127 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="162.013,152.252 98.466,178.573 93.681,167.02 " /><polygon style={{
    fill: "#FFE15A"
  }} points="23.367,209.681 91.699,194.913 82.127,171.805 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="23.367,209.681 86.913,183.359 91.699,194.913 " /><polygon style={{
    fill: "#FFE15A"
  }} points="121.404,111.643 83.529,170.404 106.636,179.975 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="121.404,111.643 95.083,175.189 83.529,170.404 " /><polygon style={{
    fill: "#FFE15A"
  }} points="63.976,250.289 101.85,191.528 78.743,181.957 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="63.976,250.289 90.296,186.743 101.85,191.528 " /><polygon style={{
    fill: "#FFE15A"
  }} points="162.013,209.681 103.252,171.805 93.681,194.913 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="162.013,209.681 98.466,183.359 103.252,171.805 " /><polygon style={{
    fill: "#FFE15A"
  }} points="23.367,152.252 82.127,190.127 91.699,167.02 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="23.367,152.252 86.913,178.573 82.127,190.127 " /><polygon style={{
    fill: "#FFE15A"
  }} points="92.69,105.932 80.184,174.713 105.195,174.713 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="92.69,105.932 92.69,174.713 80.184,174.713 " /><polygon style={{
    fill: "#FFE15A"
  }} points="92.69,256.001 105.195,187.219 80.184,187.219 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="92.69,256.001 92.69,187.219 105.195,187.219 " /><polygon style={{
    fill: "#FFE15A"
  }} points="167.724,180.966 98.943,168.461 98.943,193.471 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="167.724,180.966 98.943,180.966 98.943,168.461 " /><polygon style={{
    fill: "#FFE15A"
  }} points="17.655,180.966 86.436,193.471 86.436,168.461 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="17.655,180.966 86.436,180.966 86.436,193.471 " /><polygon style={{
    fill: "#FFE15A"
  }} points="145.747,127.909 88.268,167.702 105.954,185.388 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="145.747,127.909 97.111,176.545 88.268,167.702 " /><polygon style={{
    fill: "#FFE15A"
  }} points="39.633,234.023 97.111,194.231 79.425,176.545 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="39.633,234.023 88.268,185.388 97.111,194.231 " /><polygon style={{
    fill: "#FFE15A"
  }} points="145.747,234.023 105.954,176.545 88.268,194.231 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="145.747,234.023 97.111,185.388 105.954,176.545 " /><polygon style={{
    fill: "#FFE15A"
  }} points="39.633,127.909 79.425,185.388 97.111,167.702 " /><polygon style={{
    fill: "#FFCD5A"
  }} points="39.633,127.909 88.268,176.545 79.425,185.388 " /><circle style={{
    fill: "#FFE15A"
  }} cx={92.69} cy={180.97} r={25.01} /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };